import {SettingsService} from "../services/settings"

export const SettingsActions = {
    table,
    update,
}

function table(name) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({type: "LOADING", payload: true})
        dispatch({type: "SETTINGS_TABLE_REQUEST"})

        SettingsService.table(name)
            .then(
                settings => {
                    dispatch({type: "SETTINGS_TABLE", payload: settings})
                    dispatch({type: "LOADING", payload: false})
                    resolve(settings)
                },
                error => {
                    dispatch({type: "SETTINGS_TABLE_FAILURE"})
                    dispatch({type: "LOADING", payload: false})
                    dispatch({type: "ALERT_ERROR", payload: {
                            message: error.message,
                            type:'error'
                        }})
                    reject(error)
                }
            )
    })
}

function update(params) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch({type: "SETTINGS_TABLE_UPDATE_REQUEST"})

        SettingsService.update(params)
            .then(
                () => {
                    dispatch({type: "SETTINGS_TABLE_UPDATE"})
                    resolve()
                },
                error => {
                    dispatch({type: "SETTINGS_TABLE_UPDATE_FAILURE"})
                    dispatch({type: "ALERT_ERROR", payload: {
                            message: error.message,
                            type:'error'
                        }})
                    reject(error)
                }
            )
    })
}
